import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { useRouteMatch } from "react-router-dom";

import { fetchCustomFields } from "actions/fields/fields";
import { updateWidgetContent } from "actions/editor";

import _ from "lodash";
import cx from 'classnames';
import { Button, Form } from 'react-bootstrap'

import { EditorContext } from "components/Editor";
import StoryboardContext from "components/Storyboard/context";
import { Property } from '.';

import { useWidgetChildrenSelector } from 'components/Editor/hooks/useEditorSession';

import { getBaseUrl } from "services/util";
import TruncatedTextWithTooltip from 'components/TruncatedTextWithTooltip';

import styles from './properties.module.scss';

import {
  CONTENT_FILTER
} from "constants/widgetTypes";


const CreateFilter = ({ id, widget, position, changeView, create, ...rest }) => {

  const dispatch = useDispatch();

  let { url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;
  const storyboardContext = React.useContext(StoryboardContext);

  const contentFilters = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    return widgets.find(item => item.parent === id && item.type === CONTENT_FILTER);
  });

  const filterContainerWidget = useWidgetChildrenSelector(editorSession, _.get(contentFilters, 'uid', ''));
  const filterContainerWidgetID = _.get(_.head(filterContainerWidget), 'uid', '');
  const filterContent = _.get(_.head(filterContainerWidget), 'content') || [];

  const customFields = useSelector((state) => _.get(state, "fields.items") || []);
  const [selectedCustomFields, setSelectedCustomFields] = useState(filterContent);

  useEffect(() => {
    dispatch(fetchCustomFields(storyboardContext.id));
  }, []);

  const handleCustomFieldsSelection = (e, field) => {
    e.stopPropagation();
    const selectedFieldID = _.some(selectedCustomFields, { id: field.id });
    if (selectedFieldID) {
      setSelectedCustomFields(selectedCustomFields.filter((item) => item.id !== field.id));
    } else {
      setSelectedCustomFields([...selectedCustomFields, field]);
    }
  }

  const handleManageCustomFields = () => {
    let customFieldURL = `${baseUrl}/storyboards/${storyboardContext.id}/custom-fields/`;
    const win = window.open(customFieldURL, "_blank");
    win.focus();
  }

  const handleSubmitCustomFields = () => {
    dispatch(updateWidgetContent(editorSession, filterContainerWidgetID, selectedCustomFields));
    changeView('grid-options');
  }

  return (
    <Property.Dialog className={styles.customFieldsDialog}
      width={300}
      target={create ? `#${id}` : `#${filterContainerWidgetID}`}
      title={'Custom Fields'}
      onBack={() => changeView('grid-options')}
      onCancel={rest.onCancel}
    >
      <div className={styles.body}>
        {customFields && customFields.length > 0 ?
          <Form className={styles.fieldsList}>
            {customFields && customFields.map(field => {
              const selectedID = _.some(selectedCustomFields, { id: field.id });
              return (
                <div className={cx(styles.fieldDetailsRow, { [styles.selected]: selectedID })}
                  onClick={(e) => handleCustomFieldsSelection(e, field)}>
                  <div className={styles.fieldName}>
                    <i className={cx(styles.icon, 'cleverstory-page')} />
                    <TruncatedTextWithTooltip content={field.name} className={styles.name} maxWidth={170} placement='top'/>
                  </div>
                  <Form.Group controlId="formBasicCheckbox" className={styles.checkboxContainer}>
                    <span>{field.options.length}</span>
                    <input type="checkbox"
                      checked={selectedID}
                      className={styles.customCheckbox}
                      onClick={(e) => handleCustomFieldsSelection(e, field)}
                    />
                  </Form.Group>
                </div>
              )
            })}
          </Form>
          :
          <div className={styles.emptyMessage}>
            No Custom Fields Found
          </div>
        }

        <div className={styles.actionContainer}>
          <Button variant='secondary' onClick={() => handleManageCustomFields()} className={styles.button}>
            Manage Custom Fields
          </Button>
          {selectedCustomFields && _.size(selectedCustomFields) > 0 &&
            <Button variant='primary' className={styles.button} onClick={() => handleSubmitCustomFields()}>
              Done
            </Button>
          }
        </div>
      </div >
    </Property.Dialog >
  )
}

export { CreateFilter }